export const AUTOFILL_DETECTION_TIMEOUT = 300; // milliseconds

const isAutofilled = (element: HTMLInputElement) => element.matches(':-internal-autofill-selected');

export default isAutofilled;
